<div class="login-container">
    <form [formGroup]="loginForm" (ngSubmit)="login()" class="card">
        <div class="header">
            <img class="login-logo" />
        </div>
        <h1 class="visually-hidden">Sign in</h1>
        <div
            role="alert"
            class="w-container"
            *ngIf="reason$ | async as reason"
            [class.info]="reason !== 'userAction'"
            [class.success]="reason === 'userAction'"
        >
            <ng-container [ngSwitch]="reason">
                <ng-container *ngSwitchCase="'userAction'">
                    <strong>Session ended</strong>
                    <p class="mb-0">You have successfully logged out.</p>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <strong>Session expired</strong>
                    <p class="mb-0">
                        You were logged out due to inactivity. Please sign in again if
                        you'd like to continue.
                    </p>
                </ng-container>
            </ng-container>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>Username</mat-label>
            <input
                matInput
                placeholder="Username"
                id="user"
                type="text"
                formControlName="username"
                required
                name="userName"
            />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <mat-label>Password</mat-label>
            <input
                matInput
                placeholder="Password"
                id="pass"
                type="password"
                formControlName="password"
                required
                name="password"
            />
        </mat-form-field>
        <ng-container
            *ngIf="{
                isSubmitted: (isSubmitted$ | async),
                error: (error$ | async)
            } as login"
        >
            <div
                role="alert"
                class="critical mt-3"
                *ngIf="login.error || (loginForm.invalid && login.isSubmitted) as error"
            >
                <ng-container *ngIf="error">
                    <h4 class="mb-0">{{ error.title }}</h4>
                    {{ error.message }}
                </ng-container>
                <ng-container *ngIf="error === true">
                    The form contains one or more errors, please correct them and try
                    again.
                </ng-container>
            </div>
            <button
                type="submit"
                class="btn primary"
                [disabled]="
                    (loginForm.invalid && login.isSubmitted) || (isLoading$ | async)
                "
            >
                Sign in
                <sb-pending-button-indicator
                    [state]="state$ | async"
                ></sb-pending-button-indicator>
            </button>
            <button type="button" class="btn secondary" (click)="resetPassword()">
                Forgot password
            </button>
        </ng-container>
    </form>
</div>
